module.exports = __webpack_public_path__ + "static/media/za.b2f370d4.svg";